"use client";

import { useEffect } from "react";

// Регистрирует service worker (нужно для установки PWA и офлайна) — ТОЛЬКО в
// production. В dev SW кэширует JS-чанки и ломает горячую перезагрузку, поэтому
// там его не регистрируем, а старый (если остался) — снимаем и чистим кэш.
//
// Версия воркера привязана к номеру сборки (07.09): адрес `/sw.js?v=<сборка>`
// меняется с каждым выкатом → браузер ставит новый воркер, тот сносит кэш
// старой оболочки. Раньше имя кэша правили руками, и после деплоя телефоны
// держали старый HTML, чанков к которому на сервере уже не было — белый экран.
export default function SwRegister() {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

    if (process.env.NODE_ENV !== "production") {
      navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()));
      if (typeof caches !== "undefined") {
        caches.keys().then((ks) => ks.forEach((k) => caches.delete(k)));
      }
      return;
    }

    const build = process.env.NEXT_PUBLIC_BUILD ?? "0";
    let reg: ServiceWorkerRegistration | null = null;
    navigator.serviceWorker
      .register(`/sw.js?v=${encodeURIComponent(build)}`)
      .then((r) => {
        reg = r;
      })
      .catch(() => {
        /* регистрация недоступна (например, http на LAN) — не критично */
      });

    // Установленное приложение живёт в фоне сутками: при каждом возвращении на
    // экран спрашиваем сервер, не вышла ли новая сборка.
    const onVisible = () => {
      if (document.visibilityState === "visible") reg?.update().catch(() => {});
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);
  return null;
}
